import { action, payload } from 'ts-action'
import { IAchAccount } from '@network/models/ach-account.model'
import { IError, IPayload } from '@network/models/global.model'

export const AchAccountsFetching = action(
  'AchAccountsFetching',
  payload<boolean>(),
)

export const GetAchAccounts = action(
  'GetAchAccounts',
  payload<IPayload<IAchAccount[]>>(),
)

export const AddAchAccount = action(
  'AddAchAccount',
  payload<IPayload<IAchAccount>>(),
)

export const DeleteAchAccount = action('DeleteAchAccount', payload<number>())

export const GetAchAccountsErrors = action(
  'GetAchAccountsErrors',
  payload<IError>(),
)
